import { api } from "api";
import { Utils } from "utils";
import { IMember } from "types";
import { ThunkType } from "store/types";

import { setRouteAuthState } from "./slice";

export const authMemberThunk =
  (email: string): ThunkType<Promise<IMember>> =>
  async (dispatch) => {
    try {
      const response = await api.https.authMember(email.toLowerCase());
      const { member } = response.data;

      const isAuthed = Boolean(member);
      dispatch(setRouteAuthState({ isAuthed, member }));

      if (member && member.id) {
        Utils.Analytics.setUserID(member.id);
      }

      return Promise.resolve(member);
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const checkMembershipStatusThunk =
  (email: string): ThunkType<Promise<IMember>> =>
  async () => {
    try {
      const response = await api.https.authMember(email);
      const { member } = response.data;

      if (!member) {
        return Promise.reject(
          new Error(
            "You don't have an active membership. Please, become a member at: https://www.buymeacoffee.com/jumpstartapp/membership"
          )
        );
      }

      const isMembershipActive = Utils.Member.isActive(member);

      if (!isMembershipActive) {
        return Promise.reject(
          new Error(
            "You don't have an active membership. Please, become a member at: https://www.buymeacoffee.com/jumpstartapp/membership"
          )
        );
      }

      return Promise.resolve(member);
    } catch (erorr) {
      return Promise.reject(erorr);
    }
  };
